/**
 * Created by Ivan on 30.01.2026
 */

let LivesFeastMissionWindow;

switch (cleverapps.config.ui) {
    case "riddles":
        LivesFeastMissionWindow = RiddlesLivesFeastWindow;
        break;
    case "wooden":
        LivesFeastMissionWindow = WoodenLivesFeastWindow;
        break;
    case "tropical":
        LivesFeastMissionWindow = TropicalLivesFeastWindow;
        break;
    case "heroes":
        LivesFeastMissionWindow = HeroesLivesFeastWindow;
}